import React from 'react';

import { cn } from '@change/ds-utils';

type ActionBarProps = React.HTMLAttributes<HTMLDivElement>;

export const ActionBar: React.FC<ActionBarProps> = ({ children, className, ...rest }) => {
	return (
		<div
			className={cn(
				'border-stroke-weaker bg-background-base fixed right-0 bottom-0 left-0 z-20 border-t p-4 md:static md:right-auto md:bottom-auto md:left-auto md:border-t-0 md:bg-transparent md:p-0',
				className,
			)}
			{...rest}
		>
			<div className="max-w-100% w-100% mx-auto my-0 md:max-w-740 lg:max-w-960">{children}</div>
		</div>
	);
};
